import {
  BLOCKS_MODE,
  BlocksConfigContextType,
  BlocksViewContainerProps
} from "@pathwright/blocks-engine"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import { Suspense } from "react"
import BlocksContentEditorContainer from "./BlocksContentEditorContainer"
import BlocksContentViewerContainer from "./BlocksContentViewerContainer"

const BlockContentContainer = (
  props: BlocksConfigContextType
) => {
  const isEditMode =
    props.mode?.toLowerCase() === BLOCKS_MODE.EDIT.toLowerCase()

  return (
    <Suspense fallback={<LoadingCircle />}>
      {isEditMode ? (
        <BlocksContentEditorContainer {...props} />
      ) : (
        <BlocksContentViewerContainer {...(props as BlocksViewContainerProps)} />
      )}
    </Suspense>
  )
}

export default BlockContentContainer
